import { useState } from "react";
import { KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const ChangePasswordCard = ({ adminToken, onChanged }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [repeat, setRepeat] = useState("");
  const [busy, setBusy] = useState(false);

  const strong = next.length >= 16 && /[a-z]/.test(next) && /[A-Z]/.test(next) && /\d/.test(next);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/change-password`, {
        method: "POST", headers: { "Content-Type": "application/json", "X-Admin-Token": adminToken },
        body: JSON.stringify({ current_password: current, new_password: next }),
      });
      const d = await res.json();
      if (res.ok) { toast.success(d.message); onChanged(); }
      else toast.error(typeof d.detail === "string" ? d.detail : "Passwort ungültig");
    } catch { toast.error("Ein Fehler ist aufgetreten"); }
    setBusy(false);
  };

  return (
    <form onSubmit={submit} className="bg-[#1A1A1A] rounded-lg border border-white/10 p-5 space-y-3 max-w-md" data-testid="change-password-card">
      <h3 className="font-semibold flex items-center gap-2"><KeyRound className="w-4 h-4 text-[#c1ff72]" /> Admin-Passwort ändern</h3>
      <div><Label>Aktuelles Passwort</Label><Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="mt-1 bg-[#0A0A0A]" autoComplete="current-password" data-testid="input-pw-current" /></div>
      <div><Label>Neues Passwort</Label><Input type="password" value={next} onChange={(e) => setNext(e.target.value)} className="mt-1 bg-[#0A0A0A]" autoComplete="new-password" data-testid="input-pw-new" /></div>
      <div><Label>Neues Passwort wiederholen</Label><Input type="password" value={repeat} onChange={(e) => setRepeat(e.target.value)} className="mt-1 bg-[#0A0A0A]" autoComplete="new-password" data-testid="input-pw-repeat" /></div>
      <p className={`text-xs ${strong ? "text-green-500" : "text-[#71717A]"}`}>Mindestens 16 Zeichen mit Groß- und Kleinbuchstaben sowie Ziffern.</p>
      {repeat && repeat !== next && <p className="text-xs text-red-400">Passwörter stimmen nicht überein.</p>}
      <Button type="submit" disabled={busy || !current || !strong || next !== repeat} className="bg-[#c1ff72] text-[#0A0A0A] hover:bg-[#a8e65c]" data-testid="btn-pw-change">
        {busy ? "Wird geändert..." : "Passwort ändern"}
      </Button>
      <p className="text-xs text-[#71717A]">Nach der Änderung werden alle Sitzungen beendet und du meldest dich mit dem neuen Passwort an.</p>
    </form>
  );
};
